// extracted by mini-css-extract-plugin
export var downArrow = "_8q-0";
export var label = "_8q-1";
export var treatmentCard = "_8q-3";
export var upArrow = "_8q-2";